var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBriefcaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24094_6356)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9996 22.9692H14.9997H8.99959H0.999787C0.447506 22.9692 -0.000244141 23.4169 -0.000244141 23.9692V41.9692C-0.000244141 43.626 1.34291 44.9692 2.99976 44.9692H44.9998C46.6566 44.9692 47.9998 43.626 47.9998 41.9692V23.9692C47.9998 23.4169 47.552 22.9692 46.9997 22.9692H38.9997H32.9996ZM32.9996 22.9692C32.4473 22.9692 31.9996 23.417 31.9996 23.9693V29.9693C31.9996 30.5216 32.4473 30.9693 32.9996 30.9693H38.9996C39.5519 30.9693 39.9996 30.5216 39.9996 29.9693V23.9693C39.9997 23.4169 39.552 22.9692 38.9997 22.9692C38.4474 22.9692 37.9997 23.417 37.9997 23.9693H33.9996C33.9996 23.417 33.5519 22.9692 32.9996 22.9692ZM8.99959 22.9692C9.55187 22.9692 9.99962 23.417 9.99962 23.9693H13.9997C13.9997 23.417 14.4474 22.9692 14.9997 22.9692C15.552 22.9692 15.9997 23.4169 15.9997 23.9692V29.9692C15.9997 30.5215 15.552 30.9692 14.9997 30.9692H8.99969C8.4474 30.9692 7.99965 30.5215 7.99956 29.9693V23.9693C7.99956 23.417 8.44731 22.9692 8.99959 22.9692Z",
    fill: "url(#paint0_linear_24094_6356)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9999 12.9687H16.9998C16.4476 12.9687 15.9998 12.521 15.9998 11.9687V7.96875C15.9998 6.31191 17.343 4.96875 18.9998 4.96875H28.9998C30.6567 4.96875 31.9998 6.31191 31.9998 7.96875V11.9688C31.9998 12.521 31.5522 12.9687 30.9999 12.9687ZM17.9999 10.9688H29.9999V7.96875C29.9999 7.41647 29.5521 6.96872 28.9998 6.96872H18.9999C18.4476 6.96872 17.9999 7.41647 17.9999 7.96875V10.9688Z",
    fill: "url(#paint1_linear_24094_6356)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9999 10.9688H2.99988C1.34303 10.9688 -0.00012207 12.3119 -0.00012207 13.9688V23.9688C-0.00012207 24.521 0.447628 24.9687 0.999909 24.9687H46.9999C47.5522 24.9687 48 24.521 48 23.9687V13.9688C47.9999 12.3119 46.6567 10.9688 44.9999 10.9688Z",
    fill: "url(#paint2_linear_24094_6356)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24094_6356",
    x1: -0.000244141,
    y1: 33.9692,
    x2: 47.9998,
    y2: 33.9692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1CBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBE2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_24094_6356",
    x1: -0.00012207,
    y1: 14.9687,
    x2: 48,
    y2: 14.9687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B71F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FB5F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_24094_6356",
    x1: -0.00012207,
    y1: 14.9687,
    x2: 48,
    y2: 14.9687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B71F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FB5F9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24094_6356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.96875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseIcon);
export default __webpack_public_path__ + "static/media/briefcase-icon.d79284cb325bc0d6483764d01d51f632.svg";
export { ForwardRef as ReactComponent };